export default __webpack_public_path__ + "static/6_25-03533071327dde5de58af82d20748b84.png";